import { useState, useEffect, useRef } from "react";
import Layout from "./common/App";
import Banner from "./section/Banner";
import Category from "./section/Category";
import ActiveJob from "./section/ActiveJob";
import WhyUs from "./section/WhyUs";
import SkillBasedJob from "./section/SkillBasedJob";
import FeaturedCompany from "./section/FeaturedCompany";
import "../../Home.css";
import CookieBanner from "./CookieBanner";

const JobseekerHome = () => {
  const [showCookie, setShowCookie] = useState(false);

  useEffect(() => {
    const cookieAccepted = localStorage.getItem("cookieAccepted");
    if (!cookieAccepted) {
      setShowCookie(true);
    }
  }, []);

  const handleAcceptCookie = () => {
    localStorage.setItem("cookieAccepted", "true");
    setShowCookie(false);
  };

  return (
    <Layout>
      <Banner />
      <Category />
      <ActiveJob />
      <WhyUs />
      <SkillBasedJob />
      <FeaturedCompany />

      <section className="appBanner pb-50">
        <div className="site-width">
          <div className="appbannerwrapper">
            <div className="row align-item-center">
              <div className="col-md-7">
                <div className="apbnrtitle">
                  <h3>Over 100K+ users are already working smarter with Hourlee — Join us today.</h3>
                  <p>
                    Join India’s fastest-growing platform for flexible, hourly-based jobs. Find trusted talent or start earning on your own terms — anytime, anywhere. Download the app now.
                  </p>
                </div>
                <div className="appbnrinput">
                  <input type="text" placeholder="Enter mobile number..." />
                  <button>Get Link</button>
                </div>
                <div className="aapbnrdownloadbtns">
                  <a href="javascript:void(0)">
                    <img
                      src={`${process.env.PUBLIC_URL}/assets/img/other/GplayOneThemeHd.png`}
                      alt="img"
                    />
                  </a>
                  <a href="javascript:void(0)">
                    <img
                      src={`${process.env.PUBLIC_URL}/assets/img/other/AppstoreOneThemeHd.png`}
                      alt="img"
                    />
                  </a>
                </div>
              </div>
              <div className="col-md-4 offset-1">
                <div className="appbnrimg">
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/img/other/aapimg.png`}
                    alt="img"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


       {showCookie && <CookieBanner onAccept={handleAcceptCookie} />}

    </Layout>
  );
};

export default JobseekerHome;
